import { Apple, Play } from "lucide-react";
import { TESTFLIGHT_URL, ANDROID_TEST_URL } from "@/lib/assets";
import { useLang } from "@/i18n/LanguageContext";

export const StoreButtons = ({ className = "" }) => {
  const { t } = useLang();
  return (
    <div className={`flex flex-col sm:flex-row gap-4 ${className}`}>
      <a
        href={TESTFLIGHT_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="store-appstore"
        className="relative inline-flex items-center gap-3 rounded-2xl bg-white px-6 py-3.5 text-slate-900 hover:bg-slate-100 transition-colors duration-300"
      >
        <span className="absolute -top-2.5 -right-2 rounded-full bg-emerald-400 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-emerald-950 shadow-lg shadow-emerald-500/30">
          {t.store.placesLimited}
        </span>
        <Apple className="h-7 w-7" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wider text-slate-500">
            {t.store.iosSub}
          </span>
          <span className="block text-base font-bold">{t.store.iosLabel}</span>
        </span>
      </a>
      <a
        href={ANDROID_TEST_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="store-googleplay"
        className="relative inline-flex items-center gap-3 rounded-2xl border border-white/15 bg-white/5 px-6 py-3.5 text-white hover:border-emerald-400/50 transition-colors duration-300"
      >
        <span className="absolute -top-2.5 -right-2 rounded-full bg-violet-400 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-violet-950 shadow-lg shadow-violet-500/30">
          {t.store.onInvitation}
        </span>
        <Play className="h-7 w-7" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wider text-slate-400">
            {t.store.androidSub}
          </span>
          <span className="block text-base font-bold">{t.store.androidLabel}</span>
        </span>
      </a>
    </div>
  );
};
